import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { borderRadius, colors, colorConstants, padding, paddingSizes } from 'theme/default'
import Flex from 'components/Flex'
import { H4 } from 'components/Typo'
import IconArrow from 'components/Icons/IconArrow'
import { inputBorderStyle } from 'components/Input'

const Container = styled(Flex).attrs(() => ({
  padding: 'medium',
  alignItems: 'center'
}))`
  position: relative;
  width: 100%;
  height: 55px;
  border-radius: ${borderRadius.small};
  background-color: ${props => props.disabled ? colorConstants.lightestGray : colorConstants.white};
  color: ${colors.text};
  ${inputBorderStyle}
`

const SelectorInput = styled.select`
  opacity: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-appearance: none;
  /* stylelint-enable */
  cursor: pointer;
`

const IconArrowContainer = styled(Flex)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: ${padding[paddingSizes.medium]};
`

class Select extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.array,
    onChange: PropTypes.func,
    renderSelected: PropTypes.func,
    valueFormatter: PropTypes.func,
    labelFormatter: PropTypes.func,
    controlled: PropTypes.bool,
    selectedOption: PropTypes.object,
    iconSize: PropTypes.string,
    Icon: PropTypes.oneOfType([ PropTypes.object, PropTypes.func ]),
    withError: PropTypes.bool,
    disabled: PropTypes.bool,
    CustomOption: PropTypes.oneOfType([ PropTypes.object, PropTypes.func ])
  }

  static defaultProps = {
    options: [],
    onChange: () => {},
    renderSelected: ({ value, label }) => <H4>{label}</H4>,
    valueFormatter: x => x.value,
    labelFormatter: x => x.label,
    controlled: false,
    Icon: IconArrow.Down,
    selectedOption: {}
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (nextProps.controlled && nextProps.selectedOption !== prevState.selectedOption) {
      return {
        selectedOption: nextProps.selectedOption
      }
    }
    return null
  }

  state = {
    selectedOption: {},
    focus: false
  }

  onChange = (e) => {
    const { name, options, valueFormatter, onChange, controlled } = this.props
    const selectedValue = e.target.value
    const selectedOption = options.find((option) => valueFormatter(option) !== undefined && valueFormatter(option).toString() === selectedValue.toString())
    if (controlled) {
      onChange(name, selectedOption)
    } else {
      this.setState({ selectedOption }, onChange(name, selectedOption))
    }
  }

  onFocus = () => {
    this.setState({ focus: true })
  }

  onBlur = () => {
    this.setState({ focus: false })
  }

  render () {
    const { className, options, valueFormatter, labelFormatter, renderSelected, iconSize, Icon, withError, name, disabled, CustomOption, ...props } = this.props
    const { selectedOption, focus } = this.state
    const selectedValue = valueFormatter(selectedOption)

    return (
      <Container className={className} withError={withError} disabled={disabled} focus={focus}>
        {renderSelected(selectedOption)}
        <SelectorInput {...props} disabled={disabled} id={name} value={selectedValue} onChange={this.onChange} onFocus={this.onFocus} onBlur={this.onBlur}>
          {options.map((option, idx) => {
            const value = valueFormatter(option)
            const label = labelFormatter(option)
            if (CustomOption) {
              return (
                <CustomOption value={value} selected={selectedValue === value} key={idx} disabled={option.disabled}>
                  {label}
                </CustomOption>
              )
            }
            return (
              <option value={value} selected={selectedValue === value} key={idx} disabled={option.disabled}>
                {label}
              </option>
            )
          })}
        </SelectorInput>
        <IconArrowContainer>
          <Icon iconSize={iconSize} fill={disabled ? colorConstants.lightGray : colors.text} />
        </IconArrowContainer>
      </Container>
    )
  }
}

export default Select
